export default {
      id: "image_2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#image_2",
      toString: function () {
        return this.url;
      }
    }